<template>
  <div style="width: 34rem;">
    <div
      v-if="attachment.has_thumbnail"
      class="w-32 float-left pr-2 pb-2"
    >
      <base64-image
        v-if="thumbnail"
        alt="Image thumbnail"
        class="object-contain"
        :base64="thumbnail"
      />
    </div>
    <div>
      <span class="line-clamp-3 mb-2 font-bold">
        {{ attachment.title }}
      </span>
      <p>{{ attachment.description }}</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref} from 'vue';
import {attachmentApi} from '@/container';
import Base64Image from '@/core/components/base-64-image/Base64Image.vue';
import ImageService from "@/core/services/ImageService";
import {Attachment} from "@/attachment/interfaces/attachment";

const {attachment} = defineProps<{
    attachment: Attachment;
    tintColor?: string;
}>();

const thumbnail = ref<string | null>(null);

onMounted(() => {
    if (attachment.has_thumbnail) {
        attachmentApi()
            .thumbnail(attachment.id)
            .then(response => {
                thumbnail.value = ImageService().arrayBufferToBase64(response);
            });
    }
});
</script>
